module.exports = __webpack_public_path__ + "img/fzurl.93027b27.png";